const shouldResetCDSSProgress = (props = {}) => {
  const { lastUpdatedDateTime, todaysDateTime } = props;
  const ONE_DAY = 1000 * 60 * 60 * 24;
  const timeDiff = Math.abs(todaysDateTime - lastUpdatedDateTime);
  const diffDays = timeDiff / ONE_DAY;

  return diffDays >= 28;
};

export default shouldResetCDSSProgress;
